import { QuoteHandledState } from 'components/Kit/HandledQuotes/types';
import {
  HandledStateFields,
  deriveHandledState,
} from 'components/Kit/HandledQuotes/utils/deriveHandledState';
import { isKitSuggestionActionable } from 'utils/completeKitSuggestion';

/**
 * Single "the rep still needs to quote this lane" check for Quick Quote suggestions:
 * not replied, quoted or skipped (server or this session), and Pending or InFlight.
 * Use it anywhere Kit or the Quick Quote / Batch Quote forms count or pick pending lanes,
 * instead of comparing `status` inline.
 */
export function isQuoteRequestActionable(
  suggestion: HandledStateFields
): boolean {
  return (
    deriveHandledState(suggestion) === QuoteHandledState.Active &&
    isKitSuggestionActionable(suggestion)
  );
}
